import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import CustomHeader from '../components/Header'
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import Select from 'react-select'
import AdvanceTable from '../components/Tables/AdvanceTable';
import GroupVRNSelect from '../containers/comps/GroupVRNSelectContainer'

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: '#7367f0'

    })
}


class MyFlaggedEvents extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            middleName: '',
            lastName: '',
            email: '',
            mobileNo: '',
            vehiclesOptions: [
                { value: '0', label: 'All Vehicles' },
                { value: '1', label: 'Vehicle(s)' },
                { value: '2', label: 'Vehicles by Group(s)' }
            ],
            entriesOptions: [
                { value: '0', label: '25' },
                { value: '1', label: '50' },
                { value: '2', label: '100' }
            ],
            notificationOptions: [
                { value: '0', label: 'All' },
                { value: '1', label: 'Suspicious Transactions' },
                { value: '2', label: 'Vehicle Health & Maintenance' }
            ],
            data: [
                { "type": "Location Mismatch", "description": "Please review details of a suspected misuse of card 1478xxxxxxx3258", "time": "1 hour ago" },
                { "type": "Location Wrong", "description": "Please review details of a suspected misuse of card 1478xxxxxxx3258", "time": "2 days ago" },
                { "type": "Location Not Found", "description": "Please review details of a suspected misuse of card 1478xxxxxxx3258", "time": "3 weeks ago" },
            ],
            columns: [
                { "HeaderText": "Type", "MappingColomn": "type" },
                { "HeaderText": "Description", "MappingColomn": "description" },
                { "HeaderText": "Time", "MappingColomn": "time" }
            ],
            PageSize: 5
        }


        this.changeHandler = this.changeHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
    }

    changeHandler(p) {
        var newState = {};
        newState[p.target.name] = p.target.value;
        this.setState(newState);
    }

    submitHandler = e => {
        e.preventDefault();

    }

    render() {

        const { firstName, middleName, lastName, email, mobileNo } = this.state;

        return (
            <>

                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">My Flagged Events</h4>
                                </div>


                                <div className="card-content">
                                    <div className="card-body"></div>

                                    <div>
                                        <Container>
                                            <Row>
                                                <GroupVRNSelect />
                                            </Row>
                                        </Container>
                                    </div><br />
                                    <form className="form" onSubmit={this.submitHandler} >
                                        <div className="form-body">
                                            <div className="row">


                                                <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <input type="date" id="dpStartTime" name="Effective Date" className="form-control" />
                                                        <label htmlFor="country-floating">Choose Start Time</label>
                                                    </div>
                                                </div>



                                                <div className="col-md-6 col-12">
                                                    <div className="form-label-group">
                                                        <input type="date" id="dpEndTime" name="Effective Date" className="form-control" />
                                                        <label htmlFor="country-floating">Choose End Time</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-6 col-12" id="text">
                                                    <div className="form-label-group">
                                                        <Select
                                                            options={this.state.entriesOptions}
                                                            styles={customStyles}
                                                            placeholder={'Display Entries on Page'}
                                                        />

                                                    </div>
                                                </div>

                                                <div className="col-12" style={{ textAlign: 'left' }}>
                                                    <button type="submit" className="btn btn-shell mr-1 mb-1">Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                </div>

                                <div className="col-md-12 col-12">
                                    <AdvanceTable data={this.state.data} columns={this.state.columns} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>

        );
    }
}

export default MyFlaggedEvents;